import React from "react";
import baseContentLayout from "../../shared/base-content/index";
import "./index.scss";
// import CreateDialog from "./dialog/create";
// import DeleteDialog from "./dialog/delete";
import MyButton from "../../shared/buttons/primary";
import * as actions from "../../../modules/setting/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CustomDatePicker from "../../shared/form-datepicker";
import moment from "moment";
import { AVAILABLE_SLOT } from "../../../constants/app";
import ConfirmModal from "./dialog/confirm";
import BookingDetail from "./dialog/booking-detail";

const Content = (props) => {
  const { id } = props.auth.user;
  const [listSeat, setListSeat] = React.useState([]);
  // const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  // const [dialogData, setDialogData] = React.useState({});
  // const [showModelByType, setShowModelByType] = React.useState(null);
  const [dateFilter, setDateFilter] = React.useState(new Date());
  const [seatIds, setSeatIds] = React.useState([]);
  const [isCheckAll, setIsCheckAll] = React.useState(false);
  const [showBookingDetail, setShowBookingDetail] = React.useState({
    isShow: false,
    bookingId: "",
  });
  const [confirmModal, setConfirmModal] = React.useState({
    message: "",
    isShow: false,
    modalType: "",
    acceptValue: "",
    seatId: "",
    modalData: {},
    time: "",
  });

  React.useEffect(() => {
    reloadSeat();
  }, []);

  // const deleteBtnClick = async (data) => {
  //   await setDialogData(data);
  //   setDeleteDialogShow(true);
  // };

  const reloadSeat = () => {
    window
      .axios({
        url: `/shop/${id}/seat/`,
        method: "get",
        params: {
          date: dateFilter,
        },
      })
      .then((result) => {
        setListSeat(result.data.results);
      });
  };

  // const onCloseModel = (data) => {
  //   setShowModelByType(null);
  //   if (!window.utils.isEmptyObject(data)) {
  //     reloadSeat();
  //   }
  // };

  // const onCloseDeleteDialog = (data) => {
  //   setDeleteDialogShow(false);
  //   if (!window.utils.isEmptyObject(data)) {
  //     reloadSeat();
  //   }
  // };

  // const createBtnClick = () => {
  //   setDialogData({});
  //   setShowModelByType("create");
  // };

  // const editBtnClick = (data) => {
  //   setDialogData(data);
  //   setShowModelByType("update");
  // };

  const handleSearch = () => {
    reloadSeat();
  };

  const handleCloseDetailBookingModal = (data) => {
    if (data) {
      reloadSeat();
    }

    setShowBookingDetail({
      bookingId: "",
      isShow: false,
    });
  };

  const SlotElement = React.memo(({ seatId, slots, modalData }) => {
    return (
      <div className="slots d-flex gap-2 flex-wrap">
        {slots.map((slot) => {
          const { start_time, end_time, status } = slot;
          const isDisabled = status !== AVAILABLE_SLOT;
          return (
            <button
              key={`${start_time}_${end_time}`}
              disabled={isDisabled}
              onClick={() =>
                handleShowConfirmModal(seatId, status, slot, modalData)
              }
              className={`seat-slot-item btn btn-sm px-3 py-2`}
              style={{ minWidth: "60px" }}
            >
              {start_time}
            </button>
          );
        })}
      </div>
    );
  });

  const handleCloseConfirmModal = () => {
    setConfirmModal({
      message: "",
      isShow: false,
      modalType: "",
      acceptValue: "",
    });
  };

  const handleShowConfirmModal = (seatId, modalType, slot, modalData) => {
    const hasBooking = slot.booking_id;
    const isAvailable = modalType === AVAILABLE_SLOT;
    if (!isAvailable && hasBooking) {
      setShowBookingDetail({
        bookingId: slot.booking_id,
        isShow: true,
      });
    } else {
      const message = isAvailable
        ? "この時間枠のステータスを『予約済み』に変更しますか？"
        : "この時間枠のステータスを『未予約』に変更しますか？";
      const formattedDate = moment(dateFilter).format("YYYY-MM-DD");
      const acceptValue = moment(
        `${formattedDate} ${slot.start_time}`,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DD HH:mm");
      setConfirmModal({
        ...confirmModal,
        message,
        isShow: true,
        modalType,
        acceptValue,
        seatId: seatIds?.length ? seatIds : [seatId],
        modalData: seatIds?.length
          ? listSeat.filter((item) => seatIds.includes(item.id))
          : [modalData],
        time: slot.start_time,
      });
    }
  };

  const handleAcceptConfirmModal = (stayDuration) => {
    let data = {
      start_time: confirmModal.acceptValue,
      seat_ids: confirmModal.seatId,
      stay_duration: Number(stayDuration),
    };

    if (confirmModal.modalType !== AVAILABLE_SLOT) {
      data["unblock"] = true;
    }

    window
      .axios({
        method: "post",
        url: `shop/${props.auth.user.id}/block-time-seat/`,
        data,
      })
      .then(() => {
        reloadSeat();
        handleCloseConfirmModal();
      });
  };

  const handleCheckSeat = (seatId) => {
    if (seatIds.includes(seatId)) {
      setSeatIds((prev) => prev.filter((id) => id !== seatId));
    } else {
      setSeatIds((prev) => [...prev, seatId]);
    }
  };

  const handleCheckAll = () => {
    if (seatIds.length === listSeat.length) {
      setSeatIds([]);
    } else {
      setSeatIds(listSeat.map((item) => item.id));
    }
  };

  const renderTableRows = (item) => {
    return (
      <tr key={item.id}>
        <td>
          <input
            type="checkbox"
            checked={seatIds.includes(item.id)}
            onChange={() => handleCheckSeat(item.id)}
          />
        </td>
        <td>
          {window._.truncate(item.table?.name, {
            length: 30,
            omission: "...",
          })}
          {" - "}
          {item.seat_name}
        </td>
        <td>{item.seat_no || ""}</td>
        <td className="buttons">
          <SlotElement
            seatId={item.id}
            slots={item.available_slots}
            variant="edit"
            modalData={item}
          />
        </td>
        {/* <td className="buttons">
          <SlotElement
            seatId={item.id}
            slots={unAvailable}
            variant="delete"
            modalData={item}
          />
        </td> */}
        {/* <td className="buttons">
          <MyButton
            className="me-2"
            myVariant="edit"
            onClick={() => editBtnClick(item)}
          >
            編集
          </MyButton>
          <MyButton myVariant="delete" onClick={() => deleteBtnClick(item)}>
            削除
          </MyButton>
        </td> */}
      </tr>
    );
  };

  return (
    <div className="seat-available">
      <div className="seat-available__search mb-4">
        <div className="form-group d-inline-block me-3">
          <CustomDatePicker
            className="form-control"
            option={{
              selectedDate: dateFilter ? moment(dateFilter).toDate() : null,
              placeholder: "YYYY年MM月DD日",
            }}
            dateFormat="yyyy年MM月dd日"
            onChange={(date) => {
              setDateFilter(moment(date).format("YYYY-MM-DD"));
            }}
          />
        </div>
        <MyButton myVariant="search" className="me-3" onClick={handleSearch}>
          検索
        </MyButton>
        {/* <MyButton myVariant="add" onClick={createBtnClick}>
          ＋ 座席を追加
        </MyButton> */}
      </div>
      <div className="history__table seat-available__table">
        <table className="table">
          <thead className="">
            <tr>
              <th scope="col" className="col-checkbox">
                <input
                  type="checkbox"
                  checked={seatIds.length === listSeat.length}
                  onChange={handleCheckAll}
                />
              </th>
              <th scope="col" className="col-username">
                座席名
              </th>
              <th scope="col" className="col-seat-no">
                座席タイプ
              </th>
              <th scope="col" className="col-seat">
                空き時間
              </th>
              {/* <th scope="col" className="col-seat">
                満席時間
              </th> */}
              {/* <th scope="col" className="col-activity">
                操作
              </th> */}
            </tr>
          </thead>
          <tbody>
            {listSeat && listSeat?.length ? (
              listSeat?.map((item) => renderTableRows(item))
            ) : (
              <tr>
                <td colSpan="5">データなし</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* {showModelByType && (
        <CreateDialog
          showByType={showModelByType}
          onclose={onCloseModel}
          detailData={dialogData}
        />
      )} */}
      {confirmModal.isShow && (
        <ConfirmModal
          modalData={confirmModal.modalData}
          time={confirmModal.time}
          onClose={handleCloseConfirmModal}
          onAccept={handleAcceptConfirmModal}
        />
      )}
      {/* {deleteDialogShow && (
        <DeleteDialog
          isShow={deleteDialogShow}
          onClose={onCloseDeleteDialog}
          data={dialogData}
        />
      )} */}
      {showBookingDetail.isShow && (
        <BookingDetail
          {...showBookingDetail}
          onClose={handleCloseDetailBookingModal}
        />
      )}
    </div>
  );
};
const SeatContent = baseContentLayout(Content);

class index extends React.Component {
  render() {
    return <SeatContent name="座席設定" {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(index);
